import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-the-a01-point-notification-panel-thanksOnlyPoint__detail" }
const _hoisted_2 = { class: "p-the-a01-point-notification-panel-thanksOnlyPoint__detail__text" }
const _hoisted_3 = {
  class: "u-text-weight--bold",
  "data-translate-skip": ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PointNotificationPanelSmall = _resolveComponent("PointNotificationPanelSmall")!

  return (_openBlock(), _createBlock(_component_PointNotificationPanelSmall, {
    url: _ctx.url,
    class: _normalizeClass(["p-the-a01-point-notification-panel-thanksOnlyPoint", `-${_ctx.currentIcon.color}`])
  }, {
    icon: _withCtx(() => [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentIcon.icon)))
    ]),
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.thanksOnlyPointName) + "が", 1),
      _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
      _cache[1] || (_cache[1] = _createTextVNode("付与されました！", -1))
    ]),
    detail: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.addComma(_ctx.point)) + " " + _toDisplayString(_ctx.unit.point), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["url", "class"]))
}